export enum ExperienceType {
	GAME = 'game',
	EMAIL = 'email',
	BANNER = 'banner',
	TENSION_CART = 'tensionCart',
	SMART_OPTINS = 'smartOptins',
	REWARD= 'reward',
}
